import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomI18nCatchCopy } from "./catch-copy";
import { QuestionRoomI18nName } from "./name";

import type { StandardRoomI18nCategoriesAndManagerStore } from "../../_store/categories";

type Props = {
	base: StandardRoomI18nCategoriesAndManagerStore["base"];
};

export const QuestionRoomBase = ({ base }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionRoomI18nName />
			<QuestionRoomI18nCatchCopy />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomBase.displayName = "QuestionRoomBase";
